import { render, staticRenderFns } from "./UnpublishModal.vue?vue&type=template&id=9b6e5dfa&"
import script from "./UnpublishModal.vue?vue&type=script&lang=js&"
export * from "./UnpublishModal.vue?vue&type=script&lang=js&"
import style0 from "./UnpublishModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports